// src/support/chartColorUtils.ts

/**
 * Parse a comma-separated palette string into an array of colors.
 * Keeps any non-empty token (hex, rgb(), css vars, named colors).
 */
export function parsePaletteText(text: string): string[] {
  return String(text || '')
    .split(',')
    .map((s) => s.trim())
    .filter(Boolean);
}

/**
 * Formats the palette array back into a UI-friendly string.
 */
export function formatPaletteText(colors?: any): string {
  return Array.isArray(colors) ? colors.join(', ') : '';
}

